// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","BlogPostMenu__item--admin":"hu_a","BlogPostMenu__item--moderator":"hu_b"};